import { render, staticRenderFns } from "./SectionHeader.vue?vue&type=template&id=8fd4a592&"
import script from "./SectionHeader.vue?vue&type=script&lang=ts&"
export * from "./SectionHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SectionHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports